import Link from 'next/link';

import { ActionButtonProps, LinkButtonProps } from '../types';

type Props = Record<string, unknown> & {
  children?: React.ReactNode;
  className?: string;
};

// Renders the right host element for the given interaction props without
// swapping the component identity between renders.
export const ButtonBase = ({
  href,
  onClick,
  ...props
}: Props & (ActionButtonProps | LinkButtonProps)) => {
  if (!href) {
    return <button onClick={onClick} {...props} />;
  }

  if (href.includes('http') || href.includes('https')) {
    return (
      <a target="_blank" rel="noreferrer nofollow" href={href} {...props} />
    );
  }

  return <Link href={href} {...props} />;
};
